import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import {
  TicketAnswerDto,
  TicketDetailDto,
  TicketDto,
  TicketType,
} from "./type";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

export const GetTicketDetailsByEntityId = createAction(
  "GET_DASHBOARD_TICKETS_DETAILS_ENTITY_ID",
  ({ payload, id }: SagaActionParams<TicketDetailDto>) => ({
    payload,
    url: "/api/admin/tickets/byentityId/" + id,
  })
);
export const getClosedTickets = createAction(
  "GET_CLOSED_TICKET",
  ({ payload }: SagaActionParams<TicketDto[]>) => ({
    payload,
    url: "/api/admin/tickets/closed/list",
  })
);

export const getOpenedTickets = createAction(
  "GET_OPENED_TICKET",
  ({ payload }: SagaActionParams<TicketDto[]>) => ({
    payload,
    url: "/api/admin/tickets/opened/list",
  })
);
export const getTickets = createAction(
  "GET_TICKET",
  ({ payload }: SagaActionParams<TicketDto[]>) => ({
    payload,
    url: "/api/admin/tickets",
  })
);
export const getTicketTypes = createAction(
  "GET_TICKET_TYPES",
  ({ payload }: SagaActionParams<TicketType[]>) => ({
    payload,
    url: "/api/admin/tickets/get-ticket-types",
  })
);
export const getTicketStatusType = createAction(
  "GET_TICKET_STATUS_TYPE",
  ({ payload }: SagaActionParams<TicketType[]>) => ({
    payload,
    url: "/api/admin/tickets/get-ticket-status-types",
  })
);
export const postTicket = createAction(
  "POST_TICKET",
  ({ payload, body }: SagaActionParams<TicketDto>) => ({
    payload,
    url: "/api/admin/tickets",
    body,
  })
);
export const updateTicketStatus = createAction(
  "UPDATE_TICKET_STATUS",
  ({ payload, body }: SagaActionParams<TicketDto>) => ({
    payload,
    url: "/api/admin/tickets/update-status",
    body,
  })
);
export const sendTicketAnswer = createAction(
  "SEND_TICKET_ANSWER",
  ({ payload, id, body }: SagaActionParams<TicketDetailDto>) => ({
    payload,
    url: "/api/admin/tickets/post-ticket-answer/" + id,
    body,
  })
);
export const getTicketDetails = createAction(
  "GET_TICKET_DETAILS",
  ({ payload, id }: SagaActionParams<TicketDetailDto>) => ({
    payload,
    url: "/api/admin/tickets/" + id,
  })
);
export const getTicketDetailsWithCode = createAction(
  "GET_TICKET_DETAILS_WITH_CODE",
  ({ payload, id }: SagaActionParams<TicketDetailDto>) => ({
    payload,
    url: "/api/admin/tickets/detailswithcode/" + id,
  })
);
export const deleteTicket = createAction(
  "DELETE_TICKET",
  ({ payload, url }: SagaActionParams<TicketDetailDto>) => ({
    payload,
    url,
  })
);
export const getTicketAnswers = createAction(
  "GET_TICKET_ANSWERS",
  ({ payload, id }: SagaActionParams<TicketAnswerDto[]>) => ({
    payload,
    url: "/api/admin/tickets/get-ticket-answers/" + id,
  })
);
export const updatetoSolvedTicket = createAction(
  "UPDATE_TO_SOLVED",
  ({ payload, id }: SagaActionParams<TicketDetailDto>) => ({
    payload,
    url: "/api/admin/tickets/update-to-solved/" + id,
  })
);
const ticketSagas = [
  takeLatest<any>(
    updatetoSolvedTicket.toString(),
    (payload: SagaGenericParams<TicketDetailDto>) =>
      getSaga<TicketDetailDto>(payload)
  ),
  takeLatest<any>(
    GetTicketDetailsByEntityId.toString(),
    (payload: SagaGenericParams<TicketDetailDto>) =>
      getSaga<TicketDetailDto>(payload)
  ),
  takeLatest<any>(
    getTicketAnswers.toString(),
    (payload: SagaGenericParams<TicketAnswerDto[]>) =>
      getSaga<TicketAnswerDto[]>(payload)
  ),
  takeLatest<any>(
    getTickets.toString(),
    (payload: SagaGenericParams<TicketDto[]>) => getSaga<TicketDto[]>(payload)
  ),
  takeLatest<any>(
    getTicketTypes.toString(),
    (payload: SagaGenericParams<TicketType[]>) => getSaga<TicketType[]>(payload)
  ),
  takeLatest<any>(
    getTicketStatusType.toString(),
    (payload: SagaGenericParams<TicketType[]>) => getSaga<TicketType[]>(payload)
  ),
  takeLatest<any>(
    updateTicketStatus.toString(),
    (payload: SagaGenericParams<TicketDetailDto>) =>
      postSaga<TicketDetailDto>(payload)
  ),
  takeLatest<any>(
    getTicketDetails.toString(),
    (payload: SagaGenericParams<TicketDetailDto>) =>
      getSaga<TicketDetailDto>(payload)
  ),
  takeLatest<any>(
    getClosedTickets.toString(),
    (payload: SagaGenericParams<TicketDto[]>) => getSaga<TicketDto[]>(payload)
  ),
  takeLatest<any>(
    getOpenedTickets.toString(),
    (payload: SagaGenericParams<TicketDto[]>) => getSaga<TicketDto[]>(payload)
  ),
  takeLatest<any>(
    getTicketDetailsWithCode.toString(),
    (payload: SagaGenericParams<TicketDetailDto>) =>
      getSaga<TicketDetailDto>(payload)
  ),
  takeLatest<any>(
    postTicket.toString(),
    (payload: SagaGenericParams<TicketDto>) => postSaga<TicketDto>(payload)
  ),
  takeLatest<any>(
    sendTicketAnswer.toString(),
    (payload: SagaGenericParams<TicketDto>) => postSaga<TicketDto>(payload)
  ),
  takeLatest<any>(
    deleteTicket.toString(),
    (payload: SagaGenericParams<TicketDto>) => deleteSaga<TicketDto>(payload)
  ),
];
export default ticketSagas;
